import React from "react";

import toast from "components/ui/toast/Toast";
import TooltipComponent from "components/ui/tooltip/Tooltip";
import { Qualification } from "lib/types/qualifications";
import { useUpdateRecordQualification } from "../../lib/hooks/api/records/useUpdateRecordQualification";
import Button from "../ui/button/Button";

type Props = {
  procurementStage: {
    id: string;
    stage: string;
    qualification?: Qualification;
  };
  score: number | null | undefined;
  signalTypes: Record<string, string[]> | undefined;
  contextSource: string;
  noticeId: string;
  noticeName: string;
  size?: "small" | "default";
  onClick?: () => void;
};

export function HideNoticeButton({
  size = "default",
  procurementStage,
  noticeId,
  noticeName,
  signalTypes,
  score,
  contextSource,
  onClick,
}: Props) {
  const isPreEngage = procurementStage.stage.toLowerCase() !== "tender";

  const { mutate: updateRecordQualification } = useUpdateRecordQualification({
    onSuccess: () => {
      onClick?.();

      toast.message(`${noticeName} hidden for your team`);
    },
    onError: () => {
      toast.error("Failed to hide notice");
    },
  });

  return (
    <TooltipComponent content={size === "small" ? "Hide notice" : null}>
      <Button
        buttonType="secondary"
        icon="xClose"
        onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
          // Prevent slideout from opening
          e.stopPropagation();

          updateRecordQualification({
            procurementStage: { id: procurementStage.id, stage: procurementStage.stage },
            recordGuid: noticeId || "",
            signalTypes,
            score,
            qualification: isPreEngage ? "pre_engage_not_relevant" : "not_relevant",
            contextSource,
          });
        }}
      >
        {size === "default" ? "Hide notice" : null}
      </Button>
    </TooltipComponent>
  );
}
